<template>
  <div
    id="sidebar"
    :class="'sidebarSearch' + (loading?'loading':'') + ' ' + (hasResults ? 'hasResults':'noResults')"
  >

    <div class="sidebar-inner">

      <!--logo-->
      <div class="sidebar-logo">
        <div
          class="logo"
          @click="mixinGoTo('homepage',{})"
        >
          <SvgLogo />
        </div>

        <div
          class="sidebarPlaceholder"
          v-if="mixinGetIntegrationInfo().mode == 'boxset'"
        ></div>

        <div
          class="sidebar-logo-focus"
          v-if="Object.keys(boxsets).length !== 0 && mixinGetIntegrationInfo().mode == 'boxset'"
        >
          <span>Scopri le disponibilità di tutti i voucher</span>
        </div>
      </div>

      <!--boxsets-->
      <Spinner v-if="loading" />
      <div
        :class="(mixinGetIntegrationInfo().mode == 'boxset')? 'sidebar-content--boxset' : 'sidebar-content'"
        v-else
      >

        <!-- ricerca libera viene mostrato se sono in booking oppure se sono in upselling -->
        <div
          class="sidebarUnlockDestinations"
          v-if="
                (mixinGetIntegrationInfo().mode == 'booking') ||
                (this.mixinGetIntegrationInfo().upselling.enabled && unlockUpselling)
              "
        >
          <div class="info">
            <SvgInfoCircle v-b-popover.hover.top="'Accendendo questo interruttore puoi attivare la ricerca anche fuori dall\'area geografica specifica definita dal tuo voucher Salabam'" />
            <span>Ricerca libera in Italia e nel mondo</span>
          </div>
          <CustomSwitch
            :size="'sm'"
            :status="unlockDestinations"
            :switchUniqueKey="'custom-switch-unlock-destination-sidebar'"
            v-on:switch-change="toggleUnlockDestinations"
          />
        </div>

        <div
          :class="'sidebar-boxsets '+(mixinGetIntegrationInfo().sso ? 'sso' : '')"
          v-if="Object.keys(boxsets).length !== 0"
          v-bind="resultsFiltered"
        >
          <!-- tab navigation -->
          <b-tabs
            no-fade
            v-model="activeBandIndex"
            v-on:activate-tab="bandActived"
          >
            <template v-slot:tabs-end>
              <!-- utente loggato con salabam-->
              <div v-if="mixinGetIntegrationInfo().sso == false && mixinGetIntegrationInfo().integration !== false">
                <!--
                      <div
                          v-for="(value,name,index) in bands"
                          v-bind:resultsFiltered="resultsFiltered"
                          v-bind:key="'band-'+index"
                          >
                          -->

                <!-- loop inutile perché la condizione (activeBandIndex == index) mostra solo il cofanetto attivo, cioè quello del login -->

                <b-tab v-if="resultsFiltered[activeBand] !== undefined && (boxsets[activeBand] !== undefined) && (boxsets[activeBand][sidebarNights] !== undefined)/* && activeBandIndex == index*/">
                  <template v-slot:title>
                    <div
                      class="nav-boxset"
                      @click="mixinGoTo('search',{})"
                    >
                      <!-- active boxset -->
                      <div>
                        <div class="nav-boxset-info">
                          <div><img
                              class="boxsetThumbnail"
                              v-bind:src="config.boxsets_images_basepath + boxsets[activeBand][sidebarNights].image"
                            /></div>
                          <div class="nav-boxset-content">

                            <div :class="'nav-boxset-heading boxset-' + activeBand">
                              <div class="left">
                                <BoxsetIcon :className="'boxsetIcon'" />
                                <h3 class="nav-boxset-name">Salabam {{ (unlockDestinations || unlockUpselling)? '' : focus | capitalize}} {{bands[activeBand] | capitalize}}</h3>
                              </div>
                              <div class="right">
                                <div class="d-flex align-items-center">

                                  <div class="d-flex align-items-center has-bell">
                                    <svg
                                      width="24"
                                      height="26"
                                      viewBox="0 0 24 26"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M23.491 18.697C23.427 18.1035 23.1797 17.5447 22.7836 17.0981C22.3874 16.6515 21.8621 16.3394 21.2804 16.2051V10.0685C21.287 7.69384 20.3821 5.40715 18.7524 3.67992C17.1227 1.95268 14.8925 0.916544 12.5214 0.785148C11.3282 0.742319 10.1381 0.93495 9.01933 1.35203C7.90052 1.76912 6.87481 2.4025 6.00079 3.216C5.12676 4.02949 4.42155 5.00718 3.92538 6.09323C3.42921 7.17928 3.15182 8.35242 3.10904 9.54568C3.10529 9.6537 3.10304 9.76174 3.10304 9.869V16.2051C2.42393 16.3555 1.82425 16.7514 1.41905 17.3167C1.01386 17.8821 0.831658 18.5771 0.907429 19.2685C0.9832 19.96 1.31159 20.599 1.82961 21.0632C2.34763 21.5274 3.0188 21.784 3.71436 21.7837H7.82348C8.01122 22.8055 8.55114 23.7292 9.34936 24.3941C10.1476 25.059 11.1536 25.4231 12.1925 25.4231C13.2314 25.4231 14.2374 25.059 15.0356 24.3941C15.8338 23.7292 16.3737 22.8055 16.5615 21.7837H20.6706C21.4264 21.7786 22.1493 21.4734 22.6802 20.9354C23.2111 20.3973 23.5065 19.6704 23.5015 18.9145C23.5008 18.8418 23.5007 18.7698 23.491 18.697ZM12.1921 23.7873C11.5874 23.7863 10.999 23.591 10.5136 23.2303C10.0282 22.8696 9.67158 22.3625 9.49621 21.7837H14.8872C14.712 22.3624 14.3555 22.8695 13.8703 23.2302C13.385 23.5909 12.7967 23.7862 12.1921 23.7873V23.7873ZM21.5572 19.7637C21.4463 19.8902 21.3099 19.9919 21.157 20.062C21.0041 20.1322 20.8381 20.1693 20.6698 20.171H3.71738C3.54906 20.1691 3.38299 20.132 3.22998 20.0618C3.07697 19.9916 2.94043 19.8901 2.82924 19.7637C2.71701 19.6391 2.63166 19.4928 2.57849 19.3338C2.52531 19.1748 2.50548 19.0065 2.5202 18.8395C2.56428 18.5288 2.72177 18.2454 2.96233 18.0439C3.2029 17.8424 3.50953 17.737 3.82314 17.7481L4.73528 17.7279V9.869C4.73567 8.88887 4.9291 7.91838 5.30454 7.01301C5.67999 6.10764 6.23009 5.28511 6.92343 4.59233C7.61677 3.89955 8.43977 3.35008 9.34544 2.97536C10.2511 2.60065 11.2217 2.40799 12.2018 2.40838C12.2919 2.40838 12.3819 2.4084 12.4719 2.41365C14.4222 2.52658 16.2548 3.3835 17.592 4.80774C18.9291 6.23197 19.6689 8.11498 19.6587 10.0685V16.914L19.6789 17.7481H20.5708C20.8842 17.738 21.1903 17.8438 21.4306 18.0451C21.671 18.2464 21.8287 18.5293 21.8738 18.8395C21.8874 19.0071 21.8663 19.1756 21.8119 19.3346C21.7574 19.4936 21.6707 19.6397 21.5572 19.7637V19.7637Z"
                                        fill="white"
                                      />
                                    </svg>
                                    <span class="pill-number">{{resultsFiltered[activeBand].length}}</span>
                                  </div>
                                  <span class="resCopy">risultati</span>

                                </div>

                                <div
                                  v-if="(config.guiSettings.bookingHidePrice) || mixinGetIntegrationInfo().isGiftCard"
                                  class="nav-boxset-price invisible"
                                >&nbsp;</div>
                                <!--nascondo il prezzo per le gift card ma stampo comunque un div invisibile per non compromettere gli allineamenti-->
                                <div v-else>
                                  <!-- niente upselling -->
                                  <div
                                    class="nav-boxset-price"
                                    v-if="!unlockUpselling"
                                  >
                                    {{boxsets[activeBand][sidebarNights].public_price}} €
                                  </div>

                                  <!-- upselling con costo totale uguale allla availability del salabam con cui sono loggato -->
                                  <div
                                    class="nav-boxset-price"
                                    v-if="unlockUpselling && boxsets[activeBand][sidebarNights].public_price <= mixinGetIntegrationInfo().integration.salabam.public_price"
                                  >
                                    {{boxsets[activeBand][sidebarNights].public_price}} €
                                  </div>

                                  <!-- upselling necessità di pagamento con carta di credito -->
                                  <div
                                    class="nav-boxset-price"
                                    v-if="unlockUpselling && boxsets[activeBand][sidebarNights].public_price > mixinGetIntegrationInfo().integration.salabam.public_price"
                                  >
                                    + {{boxsets[activeBand][sidebarNights].public_price - mixinGetIntegrationInfo().integration.salabam.public_price}} €
                                  </div>
                                </div>

                              </div>

                              <div class="creditCards">
                                <img
                                  src="@/assets/images/credit-cards.png"
                                  v-if="unlockUpselling && boxsets[activeBand][sidebarNights].public_price > mixinGetIntegrationInfo().integration.salabam.public_price"
                                >
                              </div>

                            </div>
                            <a
                              href="#"
                              class="btn btn-block btn-secondary"
                              v-if="mixinGetIntegrationInfo().mode !== 'booking'"
                              @click="$emit('boxset-selected',boxsets[activeBand][sidebarNights])"
                            >Scegli</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </b-tab>

                <!-- this is important to match zero-based boxsets index! 
                          <b-tab v-else title-item-class="d-none" />
                      </div>-->
              </div>

              <!-- utente non loggato con salabam-->
              <div v-else>
                <div
                  v-for="(value,name,index) in bands"
                  v-bind:resultsFiltered="resultsFiltered"
                  v-bind:key="'band-'+index"
                >

                  <b-tab v-if="resultsFiltered[value] && boxsets[value] && boxsets[value][sidebarNights]">
                    <template v-slot:title>
                      <div
                        class="nav-boxset"
                        @click="mixinGoTo('search',{})"
                      >
                        <!-- active boxset -->
                        <div
                          v-if="activeBandIndex == index"
                          :class="
                                      (
                                        !(mixinGetIntegrationInfo().integration.integration == 'jointly') && //non devo essere jointly
                                        !(mixinGetIntegrationInfo().sso && mixinGetIntegrationInfo().welfare == false) && //non devo essere sso con welfare false
                                        mixinGetIntegrationInfo().sso && (mixinGetIntegrationInfo().integration.availability >= 0 && mixinGetIntegrationInfo().integration.availability < boxsets[value][sidebarNights].public_price)
                                      ) ? 'creditKo' : ''
                                      "
                        >
                          <div class="nav-boxset-info">
                            <div><img
                                class="boxsetThumbnail"
                                v-bind:src="config.boxsets_images_basepath + boxsets[value][sidebarNights].image"
                              /></div>
                            <div class="nav-boxset-content">

                              <div :class="'nav-boxset-heading boxset-' + value">
                                <div class="left">
                                  <BoxsetIcon :className="'boxsetIcon'" />
                                  <h3 class="nav-boxset-name">Salabam {{focus | capitalize}} {{bands[name] | capitalize}}</h3>
                                </div>
                                <div class="right">
                                  <div class="d-flex align-items-center">

                                    <div class="d-flex align-items-center has-bell">
                                      <svg
                                        width="24"
                                        height="26"
                                        viewBox="0 0 24 26"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M23.491 18.697C23.427 18.1035 23.1797 17.5447 22.7836 17.0981C22.3874 16.6515 21.8621 16.3394 21.2804 16.2051V10.0685C21.287 7.69384 20.3821 5.40715 18.7524 3.67992C17.1227 1.95268 14.8925 0.916544 12.5214 0.785148C11.3282 0.742319 10.1381 0.93495 9.01933 1.35203C7.90052 1.76912 6.87481 2.4025 6.00079 3.216C5.12676 4.02949 4.42155 5.00718 3.92538 6.09323C3.42921 7.17928 3.15182 8.35242 3.10904 9.54568C3.10529 9.6537 3.10304 9.76174 3.10304 9.869V16.2051C2.42393 16.3555 1.82425 16.7514 1.41905 17.3167C1.01386 17.8821 0.831658 18.5771 0.907429 19.2685C0.9832 19.96 1.31159 20.599 1.82961 21.0632C2.34763 21.5274 3.0188 21.784 3.71436 21.7837H7.82348C8.01122 22.8055 8.55114 23.7292 9.34936 24.3941C10.1476 25.059 11.1536 25.4231 12.1925 25.4231C13.2314 25.4231 14.2374 25.059 15.0356 24.3941C15.8338 23.7292 16.3737 22.8055 16.5615 21.7837H20.6706C21.4264 21.7786 22.1493 21.4734 22.6802 20.9354C23.2111 20.3973 23.5065 19.6704 23.5015 18.9145C23.5008 18.8418 23.5007 18.7698 23.491 18.697ZM12.1921 23.7873C11.5874 23.7863 10.999 23.591 10.5136 23.2303C10.0282 22.8696 9.67158 22.3625 9.49621 21.7837H14.8872C14.712 22.3624 14.3555 22.8695 13.8703 23.2302C13.385 23.5909 12.7967 23.7862 12.1921 23.7873V23.7873ZM21.5572 19.7637C21.4463 19.8902 21.3099 19.9919 21.157 20.062C21.0041 20.1322 20.8381 20.1693 20.6698 20.171H3.71738C3.54906 20.1691 3.38299 20.132 3.22998 20.0618C3.07697 19.9916 2.94043 19.8901 2.82924 19.7637C2.71701 19.6391 2.63166 19.4928 2.57849 19.3338C2.52531 19.1748 2.50548 19.0065 2.5202 18.8395C2.56428 18.5288 2.72177 18.2454 2.96233 18.0439C3.2029 17.8424 3.50953 17.737 3.82314 17.7481L4.73528 17.7279V9.869C4.73567 8.88887 4.9291 7.91838 5.30454 7.01301C5.67999 6.10764 6.23009 5.28511 6.92343 4.59233C7.61677 3.89955 8.43977 3.35008 9.34544 2.97536C10.2511 2.60065 11.2217 2.40799 12.2018 2.40838C12.2919 2.40838 12.3819 2.4084 12.4719 2.41365C14.4222 2.52658 16.2548 3.3835 17.592 4.80774C18.9291 6.23197 19.6689 8.11498 19.6587 10.0685V16.914L19.6789 17.7481H20.5708C20.8842 17.738 21.1903 17.8438 21.4306 18.0451C21.671 18.2464 21.8287 18.5293 21.8738 18.8395C21.8874 19.0071 21.8663 19.1756 21.8119 19.3346C21.7574 19.4936 21.6707 19.6397 21.5572 19.7637V19.7637Z"
                                          fill="white"
                                        />
                                      </svg>
                                      <span class="pill-number">{{resultsFiltered[value].length}}</span>
                                    </div>
                                    <span class="resCopy">risultati</span>

                                  </div>
                                  <div class="nav-boxset-price">€ {{boxsets[value][sidebarNights].public_price}}</div>
                                </div>
                              </div>
                              <div v-if="mixinGetIntegrationInfo().mode !== 'booking'">
                                <!-- sito pubblico -->
                                <a
                                  v-if="mixinGetIntegrationInfo().sso == false"
                                  href="#"
                                  class="btn btn-block btn-secondary"
                                  @click="$emit('boxset-selected',boxsets[value][sidebarNights])"
                                >
                                  Scegli
                                </a>

                                <!-- sso -->
                                <div v-if="mixinGetIntegrationInfo().sso == true">
                                  <button
                                    class="btn btn-block btn-secondary"
                                    :disabled="
                                                    !(mixinGetIntegrationInfo().integration.integration == 'jointly') && //non devo essere jointly
                                                    !(mixinGetIntegrationInfo().sso && mixinGetIntegrationInfo().welfare == false) && //non devo essere sso con welfare false
                                                    mixinGetIntegrationInfo().integration.availability >= 0 &&
                                                    mixinGetIntegrationInfo().integration.availability < boxsets[value][sidebarNights].public_price
                                                    "
                                    @click="$emit('boxset-selected',boxsets[value][sidebarNights])"
                                  >
                                    Scegli
                                  </button>

                                  <span
                                    class="creditKoCopy visible"
                                    v-if="
                                                    //mixinGetIntegrationInfo().integration.integration !== 'jointly' &&
                                                    mixinGetIntegrationInfo().integration.availability >= 0 &&
                                                    mixinGetIntegrationInfo().integration.availability < boxsets[value][sidebarNights].public_price
                                                  "
                                  >
                                    <CreditInfo />
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- non-active boxset -->

                        <div
                          v-else
                          :class="
                                        (
                                          mixinGetIntegrationInfo().sso &&
                                          !(mixinGetIntegrationInfo().integration.integration == 'jointly') && //non devo essere jointly
                                          !(mixinGetIntegrationInfo().sso && mixinGetIntegrationInfo().welfare == false) && //non devo essere sso con welfare false
                                          (mixinGetIntegrationInfo().integration.availability >= 0 && mixinGetIntegrationInfo().integration.availability < boxsets[value][sidebarNights].public_price)
                                        ) ? 'creditKo' : ''
                                      "
                        >
                          <div :class="'nav-boxset-heading boxset-' + value">
                            <div class="left">
                              <BoxsetIcon :className="'boxsetIcon'" />
                              <h3 class="nav-boxset-name">{{bands[name] | capitalize}} {{focus | capitalize}}</h3>
                            </div>
                            <div class="right">
                              <div class="d-flex align-items-center has-bell">
                                <svg
                                  width="24"
                                  height="26"
                                  viewBox="0 0 24 26"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M23.491 18.697C23.427 18.1035 23.1797 17.5447 22.7836 17.0981C22.3874 16.6515 21.8621 16.3394 21.2804 16.2051V10.0685C21.287 7.69384 20.3821 5.40715 18.7524 3.67992C17.1227 1.95268 14.8925 0.916544 12.5214 0.785148C11.3282 0.742319 10.1381 0.93495 9.01933 1.35203C7.90052 1.76912 6.87481 2.4025 6.00079 3.216C5.12676 4.02949 4.42155 5.00718 3.92538 6.09323C3.42921 7.17928 3.15182 8.35242 3.10904 9.54568C3.10529 9.6537 3.10304 9.76174 3.10304 9.869V16.2051C2.42393 16.3555 1.82425 16.7514 1.41905 17.3167C1.01386 17.8821 0.831658 18.5771 0.907429 19.2685C0.9832 19.96 1.31159 20.599 1.82961 21.0632C2.34763 21.5274 3.0188 21.784 3.71436 21.7837H7.82348C8.01122 22.8055 8.55114 23.7292 9.34936 24.3941C10.1476 25.059 11.1536 25.4231 12.1925 25.4231C13.2314 25.4231 14.2374 25.059 15.0356 24.3941C15.8338 23.7292 16.3737 22.8055 16.5615 21.7837H20.6706C21.4264 21.7786 22.1493 21.4734 22.6802 20.9354C23.2111 20.3973 23.5065 19.6704 23.5015 18.9145C23.5008 18.8418 23.5007 18.7698 23.491 18.697ZM12.1921 23.7873C11.5874 23.7863 10.999 23.591 10.5136 23.2303C10.0282 22.8696 9.67158 22.3625 9.49621 21.7837H14.8872C14.712 22.3624 14.3555 22.8695 13.8703 23.2302C13.385 23.5909 12.7967 23.7862 12.1921 23.7873V23.7873ZM21.5572 19.7637C21.4463 19.8902 21.3099 19.9919 21.157 20.062C21.0041 20.1322 20.8381 20.1693 20.6698 20.171H3.71738C3.54906 20.1691 3.38299 20.132 3.22998 20.0618C3.07697 19.9916 2.94043 19.8901 2.82924 19.7637C2.71701 19.6391 2.63166 19.4928 2.57849 19.3338C2.52531 19.1748 2.50548 19.0065 2.5202 18.8395C2.56428 18.5288 2.72177 18.2454 2.96233 18.0439C3.2029 17.8424 3.50953 17.737 3.82314 17.7481L4.73528 17.7279V9.869C4.73567 8.88887 4.9291 7.91838 5.30454 7.01301C5.67999 6.10764 6.23009 5.28511 6.92343 4.59233C7.61677 3.89955 8.43977 3.35008 9.34544 2.97536C10.2511 2.60065 11.2217 2.40799 12.2018 2.40838C12.2919 2.40838 12.3819 2.4084 12.4719 2.41365C14.4222 2.52658 16.2548 3.3835 17.592 4.80774C18.9291 6.23197 19.6689 8.11498 19.6587 10.0685V16.914L19.6789 17.7481H20.5708C20.8842 17.738 21.1903 17.8438 21.4306 18.0451C21.671 18.2464 21.8287 18.5293 21.8738 18.8395C21.8874 19.0071 21.8663 19.1756 21.8119 19.3346C21.7574 19.4936 21.6707 19.6397 21.5572 19.7637V19.7637Z"
                                    fill="white"
                                  />
                                </svg>
                                <span class="pill-number">{{resultsFiltered[value].length}}</span>
                              </div>
                              <div class="nav-boxset-price">
                                <span>€ {{boxsets[value][sidebarNights].public_price}}</span>
                              </div>
                            </div>
                          </div>

                          <div
                            class="creditKoCopy"
                            v-if="mixinGetIntegrationInfo().integration.availability >= 0 && mixinGetIntegrationInfo().integration.availability < boxsets[value][sidebarNights].public_price"
                          >
                            <CreditInfo />
                          </div>
                        </div>
                      </div>
                    </template>
                  </b-tab>

                  <!-- this is important to match zero-based boxsets index! -->
                  <b-tab
                    v-else
                    title-item-class="d-none"
                  />
                </div>
              </div>

            </template>
          </b-tabs>
          <!-- tab navigation -->
        </div>

        <div
          v-if="upselling.enabled && !loading"
          class="sidebarUnlockUpselling"
        >

          <div class="upsellingBlock">
            <div class="text">
              <div class="textTitle">
                <div class="icon">
                  <SvgSettings />
                </div>
                <strong>Personalizza</strong>
              </div>
              <p>
                Modifica budget per notte e numero notti e paga la differenza con la tua carta di credito
              </p>
            </div>

            <div class="switchBox">
              <CustomSwitch
                :size="'sm'"
                :status="unlockUpselling"
                :switchUniqueKey="'custom-switch-unlock-upselling-sidebar'"
                v-on:switch-change="toggleUnlockUpselling"
              />
            </div>
          </div>

          <div
            v-if="unlockUpselling"
            class="upsellingBlock"
          >
            <div class="text">
              <div class="textTitle">
                <div class="icon">
                  <font-awesome-icon icon="moon" />
                </div>
                <p class="subBlock">Numero notti</p>
              </div>
            </div>

            <div class="nightlyPriceBox">
              <!--
                <div class="input-with-icon">
                  <b-form-select v-model="upsellingNights" :options="upsellingNightsOptions" @change="value => {setUpsellingNights(value)}"></b-form-select>
                </div>
                -->

              <span @click="nightsAddAndRemove('-')">-</span>
              <b-form-input
                type="number"
                :min="upselling.minDays"
                :max="upselling.maxDays"
                v-model="upsellingNightsInput"
                @change="nightsAddAndRemove"
              />
              <span @click="nightsAddAndRemove('+')">+</span>
            </div>
          </div>

          <div
            v-if="unlockUpselling"
            class="upsellingBlock"
          >
            <div class="text">
              <div class="textTitle">
                <div class="icon">
                  <font-awesome-icon icon="euro-sign" />
                </div>
                <p class="subBlock">Prezzo per notte</p>
              </div>
            </div>

            <div class="nightlyPriceBox">
              <span @click="nightlyPriceAddAndRemove('-')">-</span>
              <b-form-input
                v-model="nightlyPrice"
                @change="nightlyPriceAddAndRemove"
              />
              <span @click="nightlyPriceAddAndRemove('+')">+</span>
            </div>
          </div>

          <div
            v-if="unlockUpselling"
            class="upsellingBlock"
          >

            <span
              v-if="checkUpsellingTotal()"
              class="danger"
            >Il totale non può essere inferiore al valore del Salabam originario.</span>
            <span
              v-if="checkUpsellingNightlyPriceMinMax()"
              class="danger"
            >Il prezzo per notte deve essere compreso tra {{this.upselling.minNightlyPrice}} € e {{this.upselling.maxNightlyPrice}} €</span>

          </div>

          <div
            v-if="unlockUpselling"
            class="upsellingBlock resumeBlock"
          >
            <div class="resumeRow">
              <span>Totale</span>
              <span>{{nightlyPrice*upsellingNights}} €</span>
            </div>
            <div class="resumeRow">
              <span>Valore iniziale</span>
              <span>{{parseFloat(mixinGetIntegrationInfo().integration.salabam.public_price)}} €</span>
            </div>
            <div
              class="resumeRow"
              v-if="!checkUpsellingTotal()"
            >
              <span>Da saldare con carta di credito</span>
              <span>
                {{Math.max(nightlyPrice*upsellingNights - parseFloat(mixinGetIntegrationInfo().integration.salabam.public_price),0)}} €
              </span>
              <div class="creditCardUpselling">
                <span><img src="@/assets/images/credit-cards.png"></span>
              </div>
            </div>
          </div>

          <div
            v-if="unlockUpselling"
            class="upsellingBlock"
          >
            <div class="checkboxUpselling">
              <input
                v-model="checkboxUpselling"
                required
                type="checkbox"
                name="checkbox"
                id="checkbox-upselling"
              >
              <label for="checkbox-upselling">
                <p class="white">
                  La cancellazione di una prenotazione fatta aggiungendo budget con questo strumento non prevede riaccredito ma la generazione di un nuovo voucher non aggregabile con altri voucher Salabam.
                  <br>
                  <router-link
                    :to="{name: 'terms'}"
                    class="nounderline"
                    target="_blank"
                  >
                    Scopri di più...
                  </router-link>
                </p>
              </label>
            </div>
          </div>

          <div
            v-if="unlockUpselling"
            class="upsellingBlock"
          >
            <div class="searchBox">
              <b-button
                :disabled="checkUpsellingTotal() || checkUpsellingNightlyPriceMinMax() || !checkboxUpselling"
                @click="$emit('submit-search')"
              >
                Cerca
              </b-button>
              <!--
                <p v-if="checkUpsellingTotal()">
                  <br>
                  Non è possibile prenotare effettuare una prenotazione da {{nightlyPrice*upsellingNights}}€ con un Salabam da {{parseFloat(mixinGetIntegrationInfo().integration.salabam.public_price)}}€
                </p>
                -->
            </div>
          </div>

        </div>

        <!--info-box-->
        <div id="sidbar-info-box">
          <span class="underline secondary">Condizioni d'uso</span>
          <br>
          <span class="primary">Hai bisogno di assistenza?</span>
          <br>
          Scrivici ad <a
            class="secondary underline"
            href="mailto:assistenza@salabam.com"
          >assistenza@salabam.com</a>
          <!-- TODO numeri di telefono, indirizzi email etc dovrebbero essere presi dal conf -->
          <!--<br>
                o chiama lo <a href="phone:+3905411646667">0541 164 66 67</a>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Spinner from './../../atoms/spinner'
import CustomSwitch from './../../atoms/custom-switch'
import CreditInfo from '@/components/blocks/common/credit-info'
import BoxsetIcon from './../../svg/boxset-icon'
import SvgInfoCircle from './../../svg/info-circle'
import SvgLogo from '@/components/svg/logo'
import SvgSettings from '@/components/svg/settings'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faMoon } from '@fortawesome/free-solid-svg-icons'
import { faEuroSign } from '@fortawesome/free-solid-svg-icons'
library.add(faMoon)
library.add(faEuroSign)


export default {
  name: 'sidebar',
  components:
  {
    Spinner,
    BoxsetIcon,
    CustomSwitch,
    CreditInfo,
    SvgInfoCircle,
    SvgLogo,
    SvgSettings,
  },
  props:
  {
    boxsets: Object,
    bands: Object,
    resultsFiltered: Object,
    focus: String,
    loading: Boolean,
    hasResults: Boolean,
    sidebarNights: Number,
  },
  computed: {
    upsellingNights: {
      get() { return this.$store.state.dates.nights },
      set() { }
    },
    unlockUpselling: {
      get() { return this.$store.state.unlockUpselling },
      set() { }
    },
    activeBand: {
      get() { return this.$store.state.activeBand },
      set() { }
    },
    unlockDestinations: {
      get() { return this.$store.state.unlockDestinations },
      set() { }
    },
    activeBandIndex: {
      get() {
        for (let key in this.bands) {
          if (this.bands[key] == this.activeBand) {
            return (Object.keys(this.bands)).indexOf(key)
          }
        }
        return 0
      },
      set() { }
    },
  },
  data() {
    return {
      credit: 'welfare',
      config: Vue.prototype.$config,
      nights: this.$store.state.dates.nights,
      upselling: this.mixinGetIntegrationInfo().upselling,
      upsellingNightsOptions: [],
      nightlyPrice: 0,
      upsellingNightsInput: this.upsellingNights,
      checkboxUpselling: false,
    }
  },
  mounted() {
    if (Object.keys(this.boxsets).length == 0) {
      this.$parent.submitSearch({ navigate: false })
    }

    if (this.mixinGetIntegrationInfo().upselling.enabled) {
      this.upsellingNightsOptions = this.upselling.nightsOptions
      this.setUpsellingDefaultNightlyPrice()
    }
  },
  updated() {
    this.nights = this.$store.state.dates.nights
  },
  watch: {
    upsellingNights: function () {
      this.upsellingNightsInput = this.$store.state.dates.nights
    },

    // gestisco il caso in cui non trovo il valore nell'array
    // ad esempio se ho settato 14 notti, poi disabilito l'upselling e non trovo il 14 nelle notti del cofanetto, e viceversa
    // logica simile in search-form.vue
    unlockUpselling: function () {

      if (!this.mixinGetIntegrationInfo().upselling.enabled) {
        this.$emit('nightly-price-changed', this.nightlyPrice)
        return
      }

      if (!this.unlockUpselling) {
        this.$emit('nightly-price-changed', this.nightlyPrice)

        this.$nextTick(() => {
          this.$emit('submit-search')
        })

        return
      }

      let currentNights = this.nights,
        //nights = this.upsellingNightsOptions[0].value
        nights = this.mixinGetIntegrationInfo().integration.salabam.nights

      let optionOk = this.upsellingNightsOptions.filter(function (el) {
        return el.nights == currentNights
      })

      if (optionOk.length > 0) {
        nights = currentNights
      }

      this.upsellingNightsInput = this.nights
      this.setUpsellingNights(nights)
      this.setUpsellingDefaultNightlyPrice()

    }
  },
  methods:
  {
    checkUpsellingTotal() {
      let upsellingNights = this.upsellingNights,
        nightlyPrice = this.nightlyPrice,
        public_price = parseFloat(this.mixinGetIntegrationInfo().integration.salabam.public_price)

      return (nightlyPrice * upsellingNights < public_price)
    },

    checkUpsellingNightlyPriceMinMax() {
      let maxNightlyPrice = (this.upselling.maxNightlyPrice),
        minNightlyPrice = (this.upselling.minNightlyPrice)

      return (this.nightlyPrice < minNightlyPrice || this.nightlyPrice > maxNightlyPrice)
    },

    nightsAddAndRemove(value) {
      //click tasto +
      if (value == '+') {
        this.setUpsellingNights(Math.min(this.upselling.maxDays, this.upsellingNights + 1))
      }

      //click tasto -
      else if (value == '-') {
        this.setUpsellingNights(Math.max(this.upselling.minDays, this.upsellingNights - 1))
      }

      //onchange del form se compilato a mano
      else {
        value = Number(value)
        if (value < this.upselling.minDays) {
          this.setUpsellingNights(this.upselling.minDays)
          return
        }

        if (value > this.upselling.maxDays) {
          this.setUpsellingNights(this.upselling.maxDays)
          return
        }

        this.setUpsellingNights(value)
      }
    },

    nightlyPriceAddAndRemove(value) {
      let maxNightlyPrice = (this.upselling.maxNightlyPrice),
        minNightlyPrice = (this.upselling.minNightlyPrice),
        priceStep = (this.upselling.priceStep),
        nightlyPrice = parseInt(this.nightlyPrice)

      //click tasto +
      if (value == '+') nightlyPrice = nightlyPrice + priceStep

      //click tasto -
      else if (value == '-') nightlyPrice = nightlyPrice - priceStep

      //onchange del form se compilato a mano
      else {
        nightlyPrice = parseInt(value) ? parseInt(value) : 0
      }

      if (nightlyPrice < minNightlyPrice) {
        nightlyPrice = minNightlyPrice
      }
      if (nightlyPrice > maxNightlyPrice) {
        nightlyPrice = maxNightlyPrice
      }

      this.nightlyPrice = nightlyPrice

      this.$emit('nightly-price-changed', this.nightlyPrice)
    },
    setUpsellingNights(value) {
      this.upsellingNightsInput = value
      this.mixinSendMutation('setNights', value)
    },
    setUpsellingDefaultNightlyPrice() {
      if (this.nightlyPrice == 0) {
        let salabam = this.mixinGetIntegrationInfo().integration.salabam
        this.nightlyPrice = Math.ceil(parseFloat(salabam.public_price / salabam.nights))
      }

      // upselling abilitato lato backend e abilitato lato frontend
      if (this.unlockUpselling && this.mixinGetIntegrationInfo().upselling.enabled) {
        this.$emit('nightly-price-changed', this.nightlyPrice)
      }
    },
    toggleUnlockDestinations(value) {
      this.mixinSendMutation('setUnlockDestinations', value)
    },
    toggleUnlockUpselling(value) {
      this.mixinSendMutation('setUnlockUpselling', value)
    },
    changeCredit: function (e) {
      if (e.target.className == 'custom-control-label' | e.target.className == 'custom-control-input') {
        let parent = e.target.parentNode
        let input = parent.querySelectorAll('input')[0]
        this.credit = input.value
      }
    },
    bandActived: function (e) {
      let bands = Object.keys(this.bands)
      let v = bands[e]
      let activeBandSlug = this.bands[v]
      this.mixinSendMutation('setActiveBand', activeBandSlug)
    },
  }
}
</script>

<style lang="scss">
@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/mixins";
@import "./../../../scss/_custom.scss";
#sidebar {
  .sidebar-logo {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 110px; //$search-form-desktop-height;
    padding-left: $grid-gutter-width/2;
    padding-top: $grid-gutter-width/2;
    padding-bottom: $grid-gutter-width/3;
    @include media-breakpoint-up(xxl) {
      padding-left: $grid-gutter-width;
    }

    svg {
      max-width: 65%;
    }

    .logo {
      cursor: pointer;
    }
  }
  .sidebar-logo-focus {
    position: relative;
    //padding-right:$grid-gutter-width;
    display: flex;
    justify-content: center; // flex-end;
    align-items: center;
    color: $white;
    font-size: 16px;
    padding-right: 20px;
    //font-weight:bold;
    svg {
      margin-left: $grid-gutter-width/3;
      min-width: 28px;
    }
    &:after {
      content: "";
      position: absolute;
      width: 35px;
      height: 35px;
      top: 50%;
      right: 0;
      transform: translateY(-50%) translateX(50%);
      background: $primary;
      border-radius: 50%;
    }
  }

  .sidebar-content--boxset {
    @include media-breakpoint-up(lg) {
      position: sticky;
      top: 20px;
    }
  }

  .sidebarPlaceholder {
    min-height: 85px;
  }

  .sidebarUnlockUpselling {
    @extend .sidebar-boxsets;

    padding-right: $grid-gutter-width/2;
    margin-top: 2rem;

    svg * {
      fill: $white;
    }

    p {
      font-size: 12px;
      color: $white;
      margin-bottom: 0;
    }

    .danger {
      min-width: 100%;
      padding-top: 0.5rem;
      text-align: center;
      margin-bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: left;
      line-height: 120%;
      svg {
        margin-right: 8px;
        width: 16px;
        min-width: 16px;
        * {
          fill: $danger;
        }
      }
    }

    .upsellingBlock {
      display: flex;
      flex-wrap: wrap;
      padding-bottom: 1.75rem;
      padding-left: 1.5rem;
      &:first-child,
      &:last-child {
        padding-left: 0;
      }

      .icon {
        display: flex;
        align-content: center;
        svg {
          width: 18px;
          height: auto;
          margin-right: 8px;
        }
        svg[data-icon="euro-sign"] {
          width: 12px;
          margin-right: 7px;
        }
        svg[data-icon="moon"] {
          width: 15px;
          margin-right: 6px;
        }
      }
      .text {
        flex: 1;
        //display:flex;
        //align-items: center;
        .textTitle {
          color: $white;
          display: flex;
          margin-bottom: 0.35rem;
        }
        strong {
          font-size: 1.15rem;
        }
      }
      .subBlock {
        font-size: 0.9rem;
      }
      input,
      select {
        padding: 4px 10px;
        //font-size: 14px;
        text-align: center;
        height: 30px;
        box-shadow: none;
      }
    }

    .switchBox,
    .nightsBox,
    .nightlyPriceBox {
      margin-left: 2rem;
      //border:1px solid red;
      flex: 1;
      max-width: 100px;
      min-width: 100px;
      text-align: center;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      * {
        font-size: 13px;
      }
    }

    .nightsBox {
      .input-with-icon {
        margin-left: 0;
        margin-right: 0;
        //width: calc(100% - 2rem);
        width: 100%;
      }
    }

    .nightlyPriceBox {
      display: flex;
      text-align: center;
      justify-content: center;
      align-items: center;
      //min-width:100%;
      .form-control {
        //width:60px;
      }
      span {
        //margin:0 4px;
        width: 16px;
        min-width: 16px;
        height: 16px;
        border-radius: 50%;
        //background:$white;
        cursor: pointer;
        flex: 1;
        color: $white;
        font-size: 28px;
        font-weight: bold;
        line-height: 40%;
        &:first-child {
          margin-right: 6px;
        }
        &:last-child {
          margin-left: 6px;
        }
      }
    }

    .searchBox {
      //width:calc(100% - 4rem);
      width: 100%;
      margin: auto;
      padding-top: 1rem;
      .btn {
        box-shadow: none;
        font-size: 1rem;
        font-weight: bold;
        display: block;
        width: 100%;
      }
    }

    .resumeBlock {
      //border-top:1px solid $white;
    }

    .resumeRow {
      min-width: 100%;
      color: $white;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding-top: 0.85rem;
      font-size: 0.9rem;
      &:first-child {
        padding-top: 2rem;
        border-top: 1px solid $white;
        font-size: 1.1rem;
      }
      .creditCardUpselling {
        min-width: 100%;
        text-align: right;
        margin-top: 0.5rem;
      }
    }
  }

  .creditCards {
    display: block;
    min-width: 100%;
    text-align: right;
    margin-top: -0.5rem;
  }

  .custom-switch {
    label {
      border: 1px solid $medium-gray;
    }
    input:not(:checked) ~ label {
      background: $white;
      &:after {
        background: $dark-gray;
      }
    }
    .switch-off svg * {
      fill: $black;
    }
  }

  .sidebarUnlockDestinations {
    color: $white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    .info {
      padding-top: 0;
      line-height: 120%;
    }
    svg {
      max-width: 14px;
      margin-right: 6px;
      * {
        fill: $white;
      }
    }
    @include media-breakpoint-up(lg) {
      justify-content: flex-end;
      transform: translateX(-30px);
      margin-bottom: 100px;
      .info {
        text-align: left;
        display: flex;
        max-width: 140px;
        padding-right: 6px;
      }
    }
  }
  .sidebar-boxsets {
    padding-left: $grid-gutter-width/2;
    overflow: hidden;
    padding-bottom: 10px;
    @include media-breakpoint-up(xxl) {
      padding-left: $grid-gutter-width;
    }
  }

  ul.nav-tabs {
    display: flex;
    flex-direction: column;
    border-radius: 0;
    border: 0;
  }
  .nav-link {
    border: 0;
    border-radius: 0;
    background-color: transparent;
    color: $black;
    padding: 18px 22px 22px 20px;
    margin: 0;
    @include media-breakpoint-up(xxl) {
      padding: 22px 26px 26px 22px;
    }
  }
  .nav-link.active {
    background-color: $white;
    border-top-left-radius: $border-radius-large;
    border-bottom-left-radius: $border-radius-large;
    overflow: hidden;
    .nav-boxset-heading {
      margin-bottom: 0;
      flex-direction: column;
      .right {
        justify-content: center;
        padding: 1rem 0.25rem;
      }
      .resCopy {
        font-size: 11px;
      }
    }
    .nav-boxset-info {
      opacity: 1;

      @include media-breakpoint-down(xl) {
        flex-direction: column;

        & > div:first-child {
          display: flex;
          justify-content: center;
          margin-bottom: 20px;
        }
      }

      img {
        @include media-breakpoint-up(xl) {
          height: 100%;
          object-fit: cover;
          border-radius: 20px;
        }

        @include media-breakpoint-down(xl) {
          width: 60%;
        }
      }
    }
    .has-bell svg * {
      fill: $black;
    }
  }

  .nav-link:not(.active) {
    border-top-left-radius: $border-radius-large;
    border-bottom-left-radius: $border-radius-large;
    overflow: hidden;
    box-shadow: 5.25076px 5.25076px 3.75054px rgba(0, 0, 0, 0.749);
    padding-bottom: 15px;
    padding-top: 30px;

    .pill-label,
    .nav-boxset-name,
    .nav-boxset-price {
      color: $white;
      border-color: $white;
    }
    .nav-boxset-info {
      opacity: 0;
    }
  }

  .nav-boxset-heading {
    display: flex;
    justify-content: space-between;
  }

  .nav-boxset-name {
    color: $black;
    font-size: 14px;
    @include media-breakpoint-up(xl) {
      font-size: 16px;
    }
    @include media-breakpoint-up(xxl) {
      font-size: 20px;
    }
  }
  .boxsetIcon {
    min-width: 16px;
    width: 16px;
    height: 16px;
    margin-right: 6px;
    @include media-breakpoint-up(xl) {
      min-width: 22px;
      width: 22px;
      height: 22px;
      margin-right: 8px;
    }
    @include media-breakpoint-up(xxl) {
      min-width: 36px;
      width: 36px;
      height: 36px;
      margin-right: 10px;
    }
  }

  .nav-tabs .btn {
    font-weight: normal;
    font-size: 18px;
    padding-top: 0.45rem;
    padding-bottom: 0.5rem;
  }

  .left {
    display: flex;
    align-items: center;
    flex: 1;
    * {
      //white-space:nowrap;
    }
  }
  .right {
    display: flex;
    align-items: center;
  }

  .nav-boxset-name {
    margin-bottom: 0;
  }

  .nav-boxset-info {
    display: flex;
  }

  .nav-boxset-thumb {
    width: 200px;
    height: auto;
    box-shadow: $box-shadow;
    border-radius: $border-radius-medium;
    //border: 1px solid #cccccc;
    overflow: hidden;
  }

  .nav-boxset-content {
    @include media-breakpoint-up(xxl) {
      width: calc(100% - 130px);
      padding-left: 20px;
      font-size: 18px;
      max-width: 55%;
      min-width: 55%;
    }

    .left {
      @include media-breakpoint-down(xl) {
        justify-content: center;
      }
    }
  }

  .pill-label {
    font-size: 11px;
    margin-left: 6px;
  }

  .has-bell {
    position: relative;
    margin-right: 10px;
    svg {
      min-width: 25px;
      width: 25px;
      height: 23px;
      path {
        fill: $white;
      }
    }
    .pill-number {
      position: absolute;
      top: 0;
      right: 0;
      transform: translateY(-40%) translateX(40%);
    }
  }

  .nav-boxset-price {
    text-align: right;
    white-space: nowrap;
    font-size: 12px;
    font-weight: bold;
    border-left: 1px solid $black;
    margin-left: 6px;
    padding-left: 8px;
    @include media-breakpoint-up(xl) {
      margin-left: 14px;
      padding-left: 14px;
      font-size: 14px;
    }
    @include media-breakpoint-up(xxl) {
      width: 65px;
      margin-left: 18px;
      padding-left: 18px;
      font-size: 16px;
    }
  }

  .nav-boxset-credit * {
    font-size: 18px;
    font-weight: bold;
  }

  .custom-control-label {
    background: $white;
    line-height: 140%;
    &:before:not(:checked) {
      border: 2px solid $medium-gray;
      background: $white;
    }
    &:after {
      //background:$secondary;
    }
  }

  input[type="radio"]:checked + label,
  .custom-radio.active label {
    &:before {
      border-color: $secondary;
    }
    &:after {
      background: $secondary;
      border-radius: 50%;
      overflow: hidden;
      transform: scale(0.5);
    }
  }

  #sidbar-info-box {
    color: $white;
    font-size: 16px;
    font-weight: bold;
    padding: $grid-gutter-width 0 $grid-gutter-width/2 $grid-gutter-width + 20px;
  }

  .noResults {
    font-size: 13px;
    margin-top: 1rem;
  }

  @include hack-ie11 {
    .nav-boxset-info .boxsetThumbnail {
      width: 130px;
      max-width: 100%;
    }
    .nav-boxset-heading {
      display: block;
      .left {
        float: left;
      }
      .right {
        float: right;
      }
    }
    .nav-boxset-content {
      .btn {
        display: inline-block;
      }
    }
  }

  &.sidebarSearch {
    @include media-breakpoint-down(md) {
      //display:block !important;
      order: 1;
      position: absolute;
      //z-index: 1;
      top: $searchbar-mobile-height + $topbar-mobile-header-height;
      height: $sidebar-mobile-height;
      overflow: hidden;
      left: 0;
      right: 0;

      &.loading,
      &.noResults {
        display: none;
      }

      .sidebar-logo,
      #sidbar-info-box,
      .boxsetThumbnail,
      .nav-boxset-name,
      .btn,
      .right .nav-boxset-price,
      .right .resCopy,
      .creditKoCopy {
        display: none !important;
      }
      .tabs {
        max-width: 100%;
      }
      .sidebar-inner {
        height: 100%;
      }
      .sidebar-boxsets {
        padding: 0;
      }
      .nav-link.active,
      .nav-link:not(.active) {
        margin: 0;
        padding: 0;
        border-radius: 0;
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;
        box-shadow: none;
        //background:transparent;
      }
      .nav-link.active {
        border-top-left-radius: $border-radius-large;
        border-top-right-radius: $border-radius-large;
        //margin-bottom: -1px;
        position: relative;
        z-index: 1;
      }
      .nav-boxset {
        height: 51px;
        width: 50px;
        display: table-cell;
        vertical-align: middle;
      }
      .nav-boxset-heading {
        width: 100%;
        display: block !important;
        text-align: center;
        svg {
          margin: 0;
          //margin-top:-4px;
          width: 70%;
          height: auto;
        }
      }
      .left {
        display: block;
        text-align: center;
      }
      .nav-link {
        position: relative;
      }
      .right {
        padding: 0 !important;
        margin: 0 !important;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        svg {
          display: none;
        }
        .d-flex {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
        .has-bell {
          position: absolute;
          top: 0;
          left: 0;
          margin-right: 0;
        }
        .pill-number {
          transform: none;
          right: 6px;
          bottom: 4px;
          top: auto;
          font-size: 8px;
        }
      }
      .nav-boxset-content {
        width: 100%;
        padding: 0;
      }
      ul.nav-tabs {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .sso {
    .nav-link:not(.active) .creditKoCopy {
      color: $white !important;
      margin-top: 10px;

      svg path {
        fill: $white;
      }
    }

    .creditKo {
      .has-bell svg path {
        fill: $dark-gray;
      }
      .pill-number {
        background-color: $dark-gray;
        color: $white !important;
      }
      .nav-boxset-price {
        border-color: $dark-gray;
      }
    }
    .creditKoCopy {
      font-style: italic;
      //color:$light-gray;
      width: 100%;
      min-width: 100%;
      display: block;
      text-align: center;
      font-size: 11px;
      font-weight: normal;
      text-align: right;
      svg {
        width: 14px;
      }
      &.visible {
        text-align: center;
        color: $black;
        margin-top: 0.5rem;
      }
    }
  }

  @include media-breakpoint-down(md) {
    .sidebarUnlockUpselling,
    .sidebarUnlockDestinations,
    .creditCards {
      display: none;
    }
  }

  .nightlyPriceBox {
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button,
    input[type="number"] {
      //background-color:$white;
      appearance: none;
      -moz-appearance: textfield;
    }
  }

  .checkboxUpselling {
    display: flex;
    label {
      padding-left: 12px;
      cursor: pointer;
      a {
        text-decoration: underline;
        color: $white;
        font-weight: 600;
      }
      position: relative;
      &:before,
      &:after {
        content: "";
        cursor: pointer;
        position: absolute;
        left: 0;
        top: 3px;
        transform: translateX(-100%);
      }

      &:before {
        width: 10px;
        height: 10px;
        border: 1px solid $white;
      }
      &:after {
        width: 6px;
        height: 6px;
        background: transparent;
        left: -2px;
        top: 5px;
        transition: $transition-base;
      }
    }
    input {
      height: auto !important;
      margin-top: 3px;
      opacity: 0;
      &:checked ~ label:after {
        background: $white;
      }
    }
  }
}
</style>